/**
 * @desc 修改
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.SalesOwnerInfoRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/salesOwnerInfo/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
